module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@2x-9b1a1321b819000aa3f0d226124b1f53.png";